import React from "react";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="px-6 pt-6 pb-4 border-b border-slate-200 bg-white sticky top-0 z-10">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
        </div>
        {children && <div className="flex items-center gap-2">{children}</div>}
      </div>
    </div>
  );
}

export function PageBody({ children, className = "" }) {
  return <div className={"p-6 " + className}>{children}</div>;
}

export function Label({ children }) {
  return <div className="text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-500">{children}</div>;
}

export function StatCard({ label, value, hint, testid }) {
  return (
    <div className="bg-white border border-slate-200 rounded-md p-5 shadow-sm" data-testid={testid}>
      <Label>{label}</Label>
      <div className="mt-2 font-mono text-2xl tabular-nums text-slate-900 font-medium">{value}</div>
      {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
    </div>
  );
}
